export const customer_request_lang = {
  TH: {
    header_card: "คำร้องเพิ่มข้อมูล",
    header_table: "แสดงข้อมูลคำร้องเพิ่มข้อมูล",
    request_id: "รหัสคำร้อง",
    request_date: "วันที่ยื่นคำร้อง",
    customer_name: "ชื่อ/นามสกุล ผู้ยื่นคำร้อง",
    flag: "สถานะการอนุมัติ",
    remark: "ข้อมูลรายละเอียดคำร้อง",
    approve: "อนุมัติ",
    notapprove: "ไม่อนุมัติ",
    approve_detail: "คุณต้องการอนุมัติคำร้องข้อนี้ใช่ไหม ?",
    approve_title: "กรุณายืนยัน",
    create_place_req: "เพิ่มสถานจากคำร้อง",
    create_place_not_req: "เพิ่มสถานที่จากจากฟอร์ม",
    approve_cancel: "ยกเลิก",
    notapprove_detail: "คุณต้องการจะไม่อนุมัติคำร้องข้อนี้ใช่ไหม ?",
    inform_title: "ไม่สามารถดำเนินการแก้ไข",
    inform_detail: "คำร้องข้อที่ดำเนินการไปแล้ว",
    inform_confirm: "ตกลง",
    approve_getdetail: "แสดงรายละเอียด",
    show_information_back: "ย้อนกลับ",
    print: "พิมพ์เอกสาร",
    request_type: "ประเภทค่าธรรมเนียม",
    request_desc: "ความประสงค์",
    request_to: "ยื่นคำร้องต่อ",
    detail: "พิมพ์เอกสาร",
    search: "ค้นหา",
    add_request_general: "เพิ่มข้อมูลคำร้อง",
    back: "ย้อนกลับ",
    customer_error: "กรุณาเลือกผู้เสียค่าธรรมเนียม",
    customer_place: "ที่อยู่ ผู้ยื่นคำร้อง",
    customer_place_error: "กรุณาเลือกที่อยู่",
    request_to_error: "กรุณากรอกข้อมูลยืนคำร้องต่อ",
    requsst_desc_error: "กรุณากรอกข้อมูลความประสงค์",
    opinion: "ความเห็นของเจ้าหน้าที่",
    opinion_error: "กรุณากรอกข้อมูลความเห็นของเจ้าหน้าที่",
    command_error: "กรุณากรอกคำสั่ง",
    command: "คำสั่ง",
    save: "บันทึก",
    save_command: "บันทึกคำสั่ง",
    cancel: "ยกเลิก",
    saved: "ข้อมูลถูกบันทึกเรียบร้อยแล้ว!",
    errored: "ไม่สามารถบันทึกข้อมูลได้!",
    update: "อัพเดทคำสั่ง",
    status: "สถานะการอนุมัติ",
    agency_name: "ผู้สร้างคำร้อง",
    place_type:"ชนิดสถานที่",
    edit:"แก้ไขรายละเอียดคำร้อง",
    save_edit:"บันทึก"
  },
  EN: {
    header_card: "Customer Request",
    header_table: "Customer Request Information",
    request_id: "Request Id",
    create_place_req: " Add a place from the request",
    create_place_not_req: "Add a location from from a form.",

    request_date: "Request Date",
    customer_name: "Customer Name",
    flag: "Status",
    remark: "Request Information",
    approve: "Approve",
    notapprove: "Not approve",
    approve_detail: "Do you need to Approve this request, right?",
    approve_title: "Confirm ?",
    approve_cancel: "Cancel",
    notapprove_detail: "Do you need to Not Approve this request, right?",
    inform_title: "Can't process this request.",
    inform_detail: "This request processed",
    inform_confirm: "Yes",
    approve_getdetail: "Show Information",
    show_information_back: "Back",
    print: "Print Document",
    request_type: "Fee type",
    request: "Request",
    request_to: "Request to",
    detail: "Print",
    search: "Search",
    add_request_general: "Add Request General",
    back: "Back",
    customer_error: "Please choose customer",
    customer_place: "Customer Address",
    customer_place_error: "Please choose address",
    request_to_error: "Please input request to",
    request_desc: "Customer request",
    requsst_desc_error: "Please input customer request",
    opinion: "Opinion of the staff",
    opinion_error: "Please input opinion",
    command_error: "Please input opinion",
    command: "Command",
    save: "Save",
    save_command: "Save Command",
    cancel: "Cancel",
    saved: "data was saved!",
    errored: "Can't save data!",
    update: "Update Command",
    status: "Status",
    agency_name: "creator of the petition",
    place_type:"place type",
    edit:"Edit Remarks",

  }
}
